module.exports = __webpack_public_path__ + "img/rotate_left.ee09c519.svg";